/**
 * @file
 * Vue app for faq form.
 */

'use strict';

import Vue from 'vue';
import axios from 'axios';

Vue.component('faq-form', {
  template: `
    <div class="modal-dialog cg-modal-dialog" :class="submitted ? 'pr-modal-dialog-narrow' : ''">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="nauth modal-content">
        <div class="modal-body pr-form">
          <template v-if="submitted">
            <div class="pr-modal-icon">
              <img src="/themes/adaptive/images/icons/pr-thank-you.png" alt="" loading="lazy"/>
            </div>
            <div class="pr-modal-title pr-modal-title-thank">
              Спасибо за обращение!
            </div>
            <div class="pr-modal-text">
              Мы свяжемся с вами в течение 24 часов с момента поступления заявки
            </div>
            <button type="button" class="btn--green" data-dismiss="modal" aria-label="Close">
              Хорошо
            </button>
          </template>
          <template v-else>
            <div class="modal-title pr-modal-title">
              {{ form.title }}
            </div>
            <div class="pr-modal-text">
              {{ form.text }}
            </div>
            <div class="pr-form" :class="{'pr-form--loading': loading}">
              <div class="pr-form-row pr-form-row--wrap">
                <div class="pr-form-item pr-form-col pr-form-col--100">
                  <label class="pr-form-label">
                    {{ fields.category.label }}
                  </label>
                  <div class="pr-select pr-select--arrow" :class="{'pr-select--show': fields.category.show}">
                    <div
                    class="form-control pr-form-control"
                    :class="{'pr-form-control--error': fields.category.error}"
                    @click.stop="showPopup(fields.category)">
                      {{ fields.category.value ? fields.category.value.name : '&nbsp;' }}
                    </div>
                    <div class="pr-form-control pr-select-list pr-select-list--scroll" v-if="fields.category.show">
                      <ul class="list">
                        <li class="list-item" v-for="item in fields.category.options" @click.stop="choseOption(fields.category, item)">
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="pr-form-item pr-form-col pr-form-col--100" v-if="fields.category.value && fields.category.value.id == 0">
                  <label class="pr-form-label">
                    {{ fields.otherTheme.label }}
                  </label>
                  <input
                  type="text"
                  class="form-control pr-form-control"
                  :class="{'pr-form-control--error': fields.otherTheme.error}"
                  v-model="fields.otherTheme.value" />
                </div>
                <div class="pr-form-item pr-form-col pr-form-col--100" v-else-if="suggestions.length">
                  <div class="faq-links">
                    <div class="faq-links-label">
                      Посмотрите ответы по этой теме в списке ниже:
                    </div>
                    <div class="faq-links-item" v-for="item in suggestions">
                      <a :href="item.url">
                        {{ item.title }}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="pr-form-item pr-form-col pr-form-col--100">
                  <label class="pr-form-label">
                    {{ fields.question.label }}
                  </label>
                  <textarea
                  rows="3"
                  maxlength="250"
                  class="form-control pr-form-control"
                  :class="{'pr-form-control--error': fields.question.error}"
                  v-model="fields.question.value"></textarea>
                </div>
                <div class="pr-form-item pr-form-col pr-form-col--100">
                  <label class="pr-form-label pr-form-label--wrap">
                    Фотография <span class="pr-form-label-correction pr-form-label-permission">Разрешение не менее 800×600 px, в формате JPG, максимальное количество - 1 шт</span>
                    <files-uploader></files-uploader>
                  </label>
                </div>
                <div class="pr-form-item pr-form-col pr-form-col--50">
                  <label class="pr-form-label">
                    {{ fields.name.label }}
                  </label>
                  <input
                  type="text"
                  class="form-control pr-form-control"
                  :class="{'pr-form-control--error': fields.name.error}"
                  v-model="fields.name.value" />
                </div>
                <div class="pr-form-item pr-form-col pr-form-col--50">
                  <label class="pr-form-label">
                    {{ fields.email.label }}
                  </label>
                  <input
                  type="text"
                  class="form-control pr-form-control"
                  :class="{'pr-form-control--error': fields.email.error}"
                  v-model="fields.email.value" />
                </div>
              </div>
              <div class="pr-messages pr-messages--red pr-messages--mb" v-if="message" v-html="message"></div>
              <div class="pr-form-item">
                <div class="pr-form-actions">
                  <div
                    class="pr-form-button btn--green"
                    :class="{'pr-form-button--loading': loading}"
                    :disabled="loading"
                    @click="submit">
                    Отправить сообщение
                  </div>
                </div>
              </div>
              <div class="pr-form-actions-text">
                Отправляя вопрос, вы автоматически соглашаетесь с <a href="/node/255771" target="_blank" class="pr-form-actions-link">политикой конфиденциальности</a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  `,
  data() {
    return {
      form: {
        title: 'Не нашли ответа на свой вопрос?',
        text: 'Мы будем рады помочь! Отправьте нам сообщение, и мы свяжемся с вами при первой возможности.'
      },
      fields: {
        category: {
          value: '',
          show: false,
          error: false,
          required: true,
          label: 'Тема обращения',
          options: [],
        },
        otherTheme: {
          value: '',
          error: false,
          required: false,
          label: 'Введите вашу тему обращения',
        },
        name: {
          value: '',
          error: false,
          required: false,
          label: 'Ваше имя',
        },
        email: {
          value: '',
          error: false,
          required: true,
          label: 'Ваш email*',
        },
        question: {
          value: '',
          error: false,
          required: true,
          label: 'Ваш вопрос*',
        },
      },
      files: [],
      suggestions: [],
      message: '',
      loading: false,
      submitted: false,
      filesLoading: false,
    }
  },
  methods: {
    buildErrorMessage(key, response) {
      this.message = `
        Произошла ошибка №${ key }, пожалуйста, сообщите об ошибке на адрес zakaz@garshinka.ru.<br />
        <small>
          Описание ошибки: ${ response.message }
        </small>
      `;
    },
    getCategories() {
      axios.get('/api/faq/categories').then((response) => {
        this.fields.category.options = response.data;
      }).catch((response) => {
        this.buildErrorMessage(130, response);
      });
    },
    hidePopups() {
      for (const key in this.fields) {
        const field = this.fields[key];
        field.show = false;
      }
    },
    showPopup(field) {
      this.hidePopups();

      field.show = true;
    },
    choseOption(field, option) {
      field.show = false;
      field.value = option;
      if (option.id != 0) {
        this.getSuggestions();
      }
    },
    async submit() {
      if (!this.validate()) {
        return;
      }

      const fids = await this.uploadFiles();

      axios.post('/api/faq/alert', {
        file: fids ? fids[0] : null,
        contacts: this.processFields(),
      }).then(() => {
        this.submitted = true;
      }).catch((response) => {
        this.loading = false;
        this.buildErrorMessage(207, response);
      });
    },
    processFields() {
      let fields = {};

      for (const key in this.fields) {
        fields[key] = this.fields[key].value;
      }

      return fields;
    },
    async uploadFiles() {
      if (!this.files.length) {
        return;
      }

      let ids = [];
      let formData = new FormData();

      for (const file of this.files) {
        formData.append('faqFiles[]', this.dataURItoBlob(file.data), file.name);
      }

      await axios.post('/api/faq/upload-files', formData).then((response) => {
        ids = response.data.files || [];
      });

      return ids;
    },
    dataURItoBlob(dataURI) {
      let byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], {
        type: mimeString,
      });
    },
    validate() {
      this.message = '';
      this.loading = true;

      for (const key in this.fields) {
        const field = this.fields[key];
        if (field.required && !field.value) {
          field.error = true;
          this.message = 'Заполните все поля в форме';

        }
        else {
          field.error = false;
        }
      }

      if (this.message) {
        this.loading = false;
        return false;
      }

      return true;
    },
    getSuggestions() {
      axios.get('/api/faq/list/' + this.fields.category.value.id).then((response) => {
        this.suggestions = response.data;
      }).catch(() => {
        this.buildErrorMessage(294, response);
      });
    },
  },
  created() {
    document.addEventListener('click', () => {
      this.hidePopups();
    });
    jQuery('#block-faq-form').on('show.bs.modal', () => {
      if (!this.fields.category.options.length) {
        this.getCategories();
      }
    });
  },
});

Vue.component('files-uploader', {
  template: `
    <div class="pr-upload">
      <div class="pr-upload-preview" v-if="images.length > 0">
        <div v-for="(image, key) in images" class="pr-upload-preview-image">
          <img class="preview" :src="image.data"  alt=""/>
          <div class="pr-upload-preview-remove" @click="removeImage(key)"></div>
        </div>
      </div>
      <div class="pr-upload-field">
        <button type="button" class="btn-upload">
          <template v-if="images.length">
            {{ $root.declOfNum(images.length, ['Выбрана', 'Выбрано', 'Выбрано']) }} {{ images.length }} {{ $root.declOfNum(images.length, ['картинка', 'картинки', 'картинок']) }}
          </template>
          <template v-else>
            Нажмите на кнопку, чтобы выбрать фотографии
          </template>
        </button>
        <input id="pr-image-uploader" type="file" @change="previewImage" accept="image/jpg, image/jpeg" multiple />
      </div>
      <div class="pr-messages pr-messages--red pr-messages--mt" v-if="message">
        <p v-html="message"></p>
        <ul class="list" v-if="messageFiles.length">
          <li class="list-item" v-for="name in messageFiles">
            Файл {{ name }} не будет загружен
          </li>
        </ul>
      </div>
    </div>
  `,
  data() {
    return {
      images: [],
      message: '',
      messageFiles: [],
    }
  },
  methods: {
    previewImage(event) {
      this.message = '';
      this.messageFiles = [];

      this.images = [];
      this.$parent.files = [];
      const input = event.target;
      if (!input.files) {
        return;
      }

      let i = 0;
      for (const file of input.files) {
        if (file.size > 20971520) {
          this.message = 'Максимальный размер файла: 20Мб';
          this.messageFiles.push(file.name);
          continue;
        }
        else if (i > 1) {
          this.message = 'Максимальное количество файлов: 1 шт.';
          this.messageFiles.push(file.name);
          continue;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          let image = new Image();
          image.src = fileData;
          image.onload = () => {
            if (image.width >= 800 && image.height >= 600) {
              const data = {
                data: fileData,
                name: file.name,
              };
              this.images.push(data);
              this.$parent.files.push(data);
            }
            else {
              if (!this.message) {
                this.message = 'Минимальный размер изображения 800×600px, в формате JPG:';
              }
              this.messageFiles.push(file.name);
            }
          };
        }
        reader.readAsDataURL(file);

        i++;
      }
    },
    removeImage(key) {
      Vue.delete(this.images, key);
      Vue.delete(this.$parent.files, key);
    },
  },
});

if (document.getElementById('faq-form')) {
  new Vue({
    delimiters: ['${', '}'],
    comments: true,
    el: '#faq-form',
    methods: {
      declOfNum(number, titles) {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
      },
    }
  });
}
